import { type FC, useId } from 'react'

import { cx } from './utils'
import type { IconProps, OtherIconName } from './types'

const CLOUD_PATH =
    'M11.5416 3.09961C7.83421 3.09961 4.73416 5.69367 3.95515 9.16592C1.69831 10.0526 0.0996094 12.2503 0.0996094 14.8234C0.0996094 18.1794 2.82014 20.8999 6.17608 20.8999H17.8231C21.1791 20.8999 23.8996 18.1794 23.8996 14.8234C23.8996 11.8898 21.8212 9.44244 19.0561 8.87229C18.1725 5.54857 15.1438 3.09961 11.5416 3.09961Z'

const ARROW_PATH =
    'M12.636 8.36321C12.2845 8.01174 11.7147 8.01174 11.3632 8.36321L8.36321 11.3632C8.01174 11.7147 8.01174 12.2845 8.36321 12.636C8.71468 12.9875 9.28453 12.9875 9.63601 12.636L11.0996 11.1724V16.4996C11.0996 16.9967 11.5026 17.3996 11.9996 17.3996C12.4967 17.3996 12.8996 16.9967 12.8996 16.4996V11.1724L14.3632 12.636C14.7147 12.9875 15.2845 12.9875 15.636 12.636C15.9875 12.2845 15.9875 11.7147 15.636 11.3632L12.636 8.36321Z'

export const IconCloudUploading: FC<IconProps> = ({
    size = 16,
    color = '#19191A',
    className,
    alt = '',
    style,
    ...rest
}) => {
    const clipId = `cloud-upload-${useId().replace(/:/g, '')}`

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            className={cx('Icon', 'IconCloudUploading', className)}
            style={style}
            role={alt ? 'img' : undefined}
            aria-label={alt || undefined}
            aria-hidden={alt ? undefined : true}
            {...rest}
        >
            <defs>
                <clipPath id={clipId}>
                    <path d={CLOUD_PATH} />
                </clipPath>
            </defs>
            <path d={CLOUD_PATH} fill={color} />
            <g clipPath={`url(#${clipId})`}>
                <g className="IconCloudUploading__arrow">
                    <path d={ARROW_PATH} fill="#ffffff" />
                </g>
            </g>
        </svg>
    )
}

IconCloudUploading.displayName = 'Icon.CloudUploading'

export const otherIcons: Record<OtherIconName, FC<IconProps>> = {
    CloudUploading: IconCloudUploading,
}
